import React from 'react';
import './App.css';
import FeedbackForm from './components/FeedbackForm';

function App() {
  return (
    <div className="App">
      <main>
        <section className="feedback-section">
          <FeedbackForm />
        </section>
      </main>
    </div>
  );
}

export default App;
